"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const node_fetch_1 = require("node-fetch");
const errors_1 = require("../errors");
const handleError = (err, throwAs) => {
    if (err instanceof errors_1.InvalidRequestConfigError ||
        err instanceof errors_1.PollDurationError ||
        err instanceof errors_1.PollRequestAbortedError) {
        throw err;
    }
    else if (err instanceof node_fetch_1.Response) {
        throw new throwAs(err.statusText);
    }
    else {
        throw new errors_1.ReportsSDKError(err === null || err === void 0 ? void 0 : err.message);
    }
};
exports.default = handleError;
